import { LegalDocumentPage } from './legal-document-page';

export const PrivacyPolicyPage = () => <LegalDocumentPage documentKey="privacy" />;
